module.exports = __webpack_public_path__ + "img/msig.dd250a7e.jpg";